import Vue from 'vue'

const getDefaultState = () => {
    return {
        contractorCategory: {
            id: 0,
            description: ""
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async List() {

        try {
            const result = await Vue.prototype.$vanKirkApi.get("common/contractor-category/list",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listContractorCategory = result.data.result;

                return listContractorCategory;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list contractor category: [${ex}]`
            };
        }
    },

    async GetById(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`common/contractor-category/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Error to get contractor category`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Error to get contractor category: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, contractorCategoryRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.post(`common/contractor-category/create-update`, contractorCategoryRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {

                let msg = "Register updated with success!";

                if (contractorCategoryRequest.id === 0) {
                    msg = "Record created successfully";
                }

                return {
                    success: true,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: "Error to create/update register!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to create/update register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to create/update register: [${error}]`
                };
            }
        }
    },

    async Delete(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.delete(`common/contractor-category/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                return {
                    success: true,
                    message: "Register deleted with success!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to delete the register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to delete the register: [${error}]`
                };
            }
        }
    },

    async ListTypeContractorCategory() {

        try {
            const result = await Vue.prototype.$vanKirkApi.get("common/contractor-category/list-type-of-contractor-category",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listType = result.data.result;

                return listType;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list types of contractor category: [${ex}]`
            };
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.contractorCategory, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.contractorCategory;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
